(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hilite-bike-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hilite-bike-slider')) {
    customElements.define('hilite-bike-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.hbs-track');
        this.slides = [...this.querySelectorAll('.hbs-slide')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        if (this.slides.length < 2) return;
        this.querySelector('.hbs-controls').hidden = false;
        this.play = this.querySelector('[data-play]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && !window.Shopify?.designMode;
        this.hovered = false;
        this.visible = true;
        this.querySelector('[data-previous]').addEventListener('click', () => this.manual(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.manual(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.manual(index), options));
        this.play.addEventListener('click', () => { this.playing = !this.playing; this.schedule(); }, options);
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.manual(index);
        }, options);
        this.track.addEventListener('pointerdown', () => this.pause(), options);
        this.addEventListener('focusin', event => { if (!event.target.closest('[data-play]')) this.pause(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)), 100);
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .2 });
        this.observer.observe(this);
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.pause(); this.go(index, false); }
        }, options);
        this.update(0);
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect();
        clearTimeout(this.timer); clearTimeout(this.scrollTimer);
      }
      pause() { this.playing = false; this.schedule(); }
      manual(index) { this.pause(); this.go(index); }
      go(index, smooth = true) {
        index = (index + this.slides.length) % this.slides.length;
        this.slides[index].querySelector('img').loading = 'eager';
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
        this.update(index);
      }
      update(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
        this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (!this.playing) this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}: ${this.dots[this.index].getAttribute('aria-label')}`;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.play.setAttribute('aria-label', this.playing ? this.play.dataset.pauseLabel : this.play.dataset.playLabel);
        this.play.firstElementChild.textContent = this.playing ? 'Ⅱ' : '▶';
        if (this.playing && !this.hovered && this.visible && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
